import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  displayReportDivisionEntitiesSelect(event) {
    const reportDivisionInput = event.currentTarget
    const reportDivisionId = reportDivisionInput.value
    const reportDivisionInputContainer = reportDivisionInput.parentNode

    this.hideAllEntitiesSelect(reportDivisionInputContainer)

    if (reportDivisionId) {
      this.revealTargetedEntitiesSelect(reportDivisionInputContainer, reportDivisionId)
    }
  }

  // private

  revealTargetedEntitiesSelect(reportDivisionInputContainer, reportDivisionId) {
    const targetedSelect = document.querySelector(`select[data-report_division_id='${reportDivisionId}']`)
    const targetedSelectContainer = targetedSelect.parentNode

    this.insertAfter(targetedSelectContainer, reportDivisionInputContainer)

    targetedSelectContainer.style.display = 'inline-block'
  }

  hideAllEntitiesSelect(reportDivisionInputContainer) {
    this.resetFilter()
    const entitiesSelects = document.querySelectorAll("select[name='report_division_entities[]']")
    const that = this

    entitiesSelects.forEach(function (select) {
      const selectElementContainer = select.parentNode

      selectElementContainer.style.display = 'none'

      that.insertAfter(selectElementContainer, reportDivisionInputContainer)
    })
  }

  insertAfter(newNode, existingNode) {
    existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling)
  }

  resetFilter() {
    // custom event that is listened to in the multiple_select_component stimulus controller
    const event = new CustomEvent('reset')
    window.dispatchEvent(event)
  }
}
